import { css } from "styled-components";
import token from "styled-token";
import { StyledIcon } from "../../components/Icon/Icon";
import { spaceMixin } from "../spaceMixin";
import { typographyMixin } from "../typographyMixin";
import { iconOffsetMixin } from "../iconOffsetMixin";
/** @class MenuItemMixin */

/**
 * Standalone styles for a menu action item.
 *
 * @example
 * import { MenuItemMixin, IconHeart } from "@zillow/constellation";
 *
 * const Component = styled.button`
 *     ${MenuItemMixin}
 * `;
 *
 * <Component><IconHeart /> Menu item</Component>
 *
 * @method
 * @param props {object}
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */

export var MenuItemMixin = function MenuItemMixin(props) {
  return token({
    backgroundColor: "MenuItem.backgroundColor",
    backgroundColorHover: "MenuItem.backgroundColorHover",
    fontColor: "MenuItem.fontColor",
    fontType: "MenuItem.fontType",
    iconSize: "MenuItem.iconSize",
    iconColor: "MenuItem.iconColor",
    horizontalSpacing: "MenuItem.horizontalSpacing",
    verticalSpacing: "MenuItem.verticalSpacing"
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
        backgroundColorHover = _ref.backgroundColorHover,
        fontColor = _ref.fontColor,
        fontType = _ref.fontType,
        iconSize = _ref.iconSize,
        iconColor = _ref.iconColor,
        horizontalSpacing = _ref.horizontalSpacing,
        verticalSpacing = _ref.verticalSpacing;
    return css(["", " ", " align-items:center;background-color:", ";border:0;box-sizing:border-box;color:", ";cursor:pointer;display:flex;outline:none;padding:", "px ", "px;text-align:left;text-decoration:none;width:100%;&:first-child{border-top-left-radius:inherit;border-top-right-radius:inherit;}&:last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;}&::-moz-focus-inner{border:0;}&:focus:not(:disabled),&:hover:not(:disabled){background-color:", ";}&:active:not(:disabled){background-color:", ";}> ", "{color:", ";flex-shrink:0;margin-right:", ";}"], typographyMixin(Object.assign({
      fontType: fontType,
      fontTypeIconAlignment: false
    }, props)), iconOffsetMixin(Object.assign({}, props, {
      iconSize: iconSize
    })), backgroundColor, fontColor, verticalSpacing, horizontalSpacing, backgroundColorHover, backgroundColorHover, StyledIcon, iconColor, spaceMixin("xs")(props));
  })(props);
};